// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyAAGaxF7DH0SZg_V4OcQoJTVkLDHuw8C-o",
  authDomain: "journal-e2b0e.firebaseapp.com",
  projectId: "journal-e2b0e",
  storageBucket: "journal-e2b0e.appspot.com",
  messagingSenderId: "1038698114942",
  appId: "1:1038698114942:web:3794fbf704834e94eb4d2f",
  measurementId: "G-JMTJF0H12X",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const storage = getStorage(app);
